/* GeoChange V2 — in-room artwork geometry correction (2026-09-16, audit P0-4B)

   Defect: "From blank wall to collected space" and the PDP Scale slide sized the artwork with two
   independent percentage scales:
       W% = rc.w * (w / rc.refW)      H% = rc.h * (h / rc.refH)
   A percentage width resolves against the container's WIDTH and a percentage height against its
   HEIGHT, so that pair only preserves the artwork's true ratio if the container happens to have the
   aspect the reference numbers were calibrated against. It does not: the reference (26 x 40 in at
   48.69% x 58.35%) implies a container of 0.78:1, while `.ba` is 3:2. The result was a portrait work
   drawn in a landscape box — the audit measured 175x121 for a 1512x2268 artwork.

   Correction: keep the calibrated WIDTH anchor, then derive the height in real pixels from the
   artwork's own ratio and convert back to a percentage of the container. Portrait stays portrait,
   landscape stays landscape, panoramic stays panoramic, at any container aspect.

   Runs after gc-pdp.js has rendered, on load, on configurator interaction and on resize. No polling,
   no timers left running, no unbounded observers. */
(function () {
  var opts = null;
  function options() {
    if (opts) return opts;
    var el = document.querySelector('script[data-options]');
    if (!el) return null;
    try { opts = JSON.parse(el.textContent); } catch (e) { opts = null; }
    return opts;
  }

  /* The configurator writes the selected size into the captions it also renders, so the DOM is the
     single source of truth for "what is currently selected" and we never duplicate its state. */
  function selectedInches() {
    var src = document.querySelector('[data-scale-note]') || document.querySelector('[data-cap="scale"]');
    if (!src) return null;
    var m = (src.textContent || '').match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*in/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    if (!a || !b) return null;
    var o = options();
    var portrait = !o || o.portrait !== false;
    return portrait
      ? { w: Math.min(a, b), h: Math.max(a, b) }
      : { w: Math.max(a, b), h: Math.min(a, b) };
  }

  function fix() {
    var o = options();
    if (!o || !o.gallery || !o.gallery.scale) return;
    var rc = o.gallery.scale;
    var dim = selectedInches();
    if (!dim) return;

    var boxes = document.querySelectorAll('.scalebox');
    for (var i = 0; i < boxes.length; i++) {
      var sb = boxes[i];
      var a = sb.querySelector('.art');
      if (!a) continue;
      var R = sb.getBoundingClientRect();
      if (!R.width || !R.height) continue;

      var Wpct = rc.w * (dim.w / rc.refW);
      var Wpx = (Wpct / 100) * R.width;
      var Hpx = Wpx * (dim.h / dim.w);
      var Hpct = (Hpx / R.height) * 100;

      /* Never let a very large edition overflow the plate; scale the pair down together so the
         artwork keeps its ratio rather than being squashed to fit. */
      if (Hpct > 92) {
        var k = 92 / Hpct;
        Hpct *= k; Wpct *= k;
      }

      var cx = rc.x + rc.w / 2;
      var cy = rc.y + rc.h / 2;
      a.style.width = Wpct + '%';
      a.style.height = Hpct + '%';
      a.style.left = (cx - Wpct / 2) + '%';
      a.style.top = (cy - Hpct / 2) + '%';
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { queued = false; fix(); });
    });
  }

  function start() {
    schedule();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-gc-configurator]') || e.target.closest('.ba') || e.target.closest('.sheet')) schedule();
    });
    document.addEventListener('input', function (e) {
      if (e.target.closest('.ba') || e.target.closest('[data-gc-configurator]')) schedule();
    });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
